export enum Permission {
  VIEW_CASE = 'ViewCase',
  EDIT_CASE = 'EditCase'
}
